export default __webpack_public_path__ + "static/media/Epithet of Skelos.ec9b6022.jpg";